import React, {useContext} from 'react';
import classNames from 'classnames';
import {DataContext} from '../../context/DataContext'

const ChatSwitch = () => {
    const dataContext = useContext(DataContext);
    // const groupChat = dataContext.groupChat;
    // const teachers = dataContext.teachers;
    const showGroups = classNames({
        ' w-1/2 block mx-auto h-full text-xs pt-2  text-center rounded-3xl text-white bg-blue-100': true,
    });
    // const showGroups = classNames({
    //     'inline-flex w-1/2 h-full text-xs absolute switchPositionLeft justify-center items-center py-1 px-6 cursor-pointer': true,
    //     'z-10 text-white bg-blue-100': groupChat === true,
    //     'z-0 text-gray-100 bg-blue-900' : groupChat === false
    // });
    // const showTeachers = classNames({
    //     'inline-flex w-1/2 h-full text-xs absolute switchPositionRight justify-center items-center py-1 px-6 cursor-pointer': true,
    //     'z-10 text-white bg-blue-100': teachers === true,
    //     'z-0 text-gray-100 bg-blue-900' : teachers === false
    // });

    return (
        <> 
            <div className='w-full h-full relative'>
                <div onClick={()=>{dataContext.toggleGroup()}} className={showGroups}> Groups </div>
                {/* <div onClick={()=>{dataContext.toggleGroup()}} className={showTeachers}> Teachers </div> */}
            </div>
        </>
    )
}

export default ChatSwitch;